import Service from '@/service'
import HomeService from '@/service/homepage'

export default {
    data () {
        return {
            excellent_consultants: [],
            loading: true,
            items: []
        }
    },
    methods: {
        getExcellentConsultant (is_level3) {
            if (is_level3) {
                Service.getConsultants({
                    page: 1,
                    per: 3,
                    zone_levels: 3
                }).then(({ items }) => {
                    this.excellent_consultants = items
                })
            } else {
                HomeService.getConsultants().then((items) => {
                    this.excellent_consultants = items
                })
            }
        },
        goConsultant (is_level3) {
            let params = ''
            if (is_level3) {
                params = `?zone_levels=3`
            }
            wx.navigateTo({
                url: `/pages/consultants/main${params}`
            })
        },
        async getBuildings (is_level3) {
            const params = {}
            if (is_level3) {
                params.zone_levels = 3
            }
            const { items } = await Service.getBuildings(params)
            this.items = items
            this.loading = false
        }
    }
}
